import type { ActionImpl } from 'kbar';
import type { KeyboardEvent } from 'react';

const SNIPPET_MAX_LENGTH = 160;

export function cutSnippet(
  text: string,
  query: string,
  max = SNIPPET_MAX_LENGTH
): string {
  const trimmed = text.trim();
  if (trimmed.length <= max) return trimmed;

  const needle = query.trim().toLowerCase();
  const index = needle ? trimmed.toLowerCase().indexOf(needle) : -1;
  const start =
    index === -1
      ? 0
      : Math.max(
          0,
          Math.min(
            index - Math.floor((max - needle.length) / 2),
            trimmed.length - max
          )
        );
  const end = Math.min(trimmed.length, start + max);
  return `${start > 0 ? '…' : ''}${trimmed.slice(start, end)}${end < trimmed.length ? '…' : ''}`;
}

export function matchingSnippets(
  content: string,
  query: string,
  limit: number
): string[] {
  const needle = query.trim().toLowerCase();
  const lines = content.split('\n').filter((line) => line.trim());
  const matching = needle
    ? lines.filter((line) => line.toLowerCase().includes(needle))
    : [];
  return (matching.length ? matching : lines)
    .slice(0, limit)
    .map((line) => cutSnippet(line, query));
}

export function hasSubmenu(action: ActionImpl) {
  return Boolean(action.children?.length) && !action.command;
}

export function shouldEnterSubmenuOnArrowRight(
  event: KeyboardEvent<HTMLInputElement>,
  item: string | ActionImpl | undefined
) {
  if (!item || typeof item === 'string') return false;
  const { selectionStart, selectionEnd, value } = event.currentTarget;
  return (
    event.key === 'ArrowRight' &&
    !event.shiftKey &&
    !event.altKey &&
    !event.ctrlKey &&
    !event.metaKey &&
    selectionStart === value.length &&
    selectionEnd === value.length &&
    hasSubmenu(item)
  );
}
